import { render, staticRenderFns } from "./HotelBookSet.vue?vue&type=template&id=2dcd8fc7&scoped=true"
import script from "./HotelBookSet.vue?vue&type=script&lang=js"
export * from "./HotelBookSet.vue?vue&type=script&lang=js"
import style0 from "./HotelBookSet.vue?vue&type=style&index=0&id=2dcd8fc7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcd8fc7",
  null
  
)

export default component.exports